import { Modal, ModalProps } from 'react-bootstrap';

interface CustomModalProps extends ModalProps {
  children: React.ReactNode;
}

const CustomModal = ({ children, ...props }: CustomModalProps) => {
  return (
    <Modal
      keyboard={false}
      scrollable={false}
      backdrop="static"
      animation={false}
      centered
      {...props}
    >
      {children}
    </Modal>
  );
};

export default CustomModal;
